<template>
    <div class="city-select" v-if="isShow" @click.self="onHideLayer">
        <div class="city-list">
            <div class="list-title hc">请选择所在地区</div>
            <div class="list-body">
                <div class="list-item list-p">
                    <div class="selected-wrap selected-p"><span :class="`${isSelectProvince} el`">{{province}}</span></div>
                    <div class="options-wrap">
                        <ul>
                            <li v-for="(province, index) in cityList" :key="index"><span :class="`${checkProvinceIndex === index ? 'cur' : ''} el`" @click="selectProvince(index)">{{province.p}}</span></li>
                        </ul>
                    </div>
                </div>
                <div class="list-item list-c" v-if="cityArr.length > 0">
                    <div class="selected-wrap selected-c"><span :class="`${isSelectCity} el`">{{city}}</span></div>
                    <div class="options-wrap">
                        <ul>
                            <li v-for="(city, index) in cityArr" :key="index"><span :class="`${checkCityIndex === index ? 'cur' : ''} el`" @click="selectCity(index)">{{city.n}}</span></li>
                        </ul>
                    </div>
                </div>
                <div class="list-item list-z" v-if="zoneArr && zoneArr.length > 0">
                    <div class="selected-wrap selected-z"><span :class="`${isSelectZone} el`">{{zone}}</span></div>
                    <div class="options-wrap">
                        <ul>
                            <li v-for="(zone, index) in zoneArr" :key="index"><span :class="`${checkZoneIndex === index ? 'cur' : ''} el`" @click="selectZone(index)">{{zone.s}}</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import cityList from './city'
    export default {
        name: 'Region',
        props: {
            isShow: {
                type: Boolean,
                default: false
            },
            onHideLayer: {
                type: Function
            }
        },
        data: () => {
            return {
                cityList,
                isSelectProvince: '',
                checkProvinceIndex: null,
                province: '请选择',
                cityArr: [],
                isSelectCity: '',
                checkCityIndex: null,
                city: '请选择',
                zoneArr: [],
                isSelectZone: '',
                checkZoneIndex: null,
                zone: '请选择'
            }
        },
        methods: {
            selectProvince (index) {
                this.checkProvinceIndex = index
                this.isSelectProvince = 'cur'
                this.province = this.cityList[index].p
                this.cityArr = this.cityList[index].c

                //城市重置
                this.checkCityIndex = null
                this.isSelectCity = ''
                this.city = '请选择'

                //区域重置
                this.checkZoneIndex = null
                this.isSelectZone = ''
                this.zone = '请选择'
                this.zoneArr = []
            },
            selectCity (index) {
                this.checkCityIndex = index
                this.isSelectCity = 'cur'
                this.city = this.cityArr[index].n
                this.zoneArr = this.cityArr[index].a

                if (this.zoneArr === undefined) {
                    this.$emit('on-select', {province: this.province, city: this.city})
                }

                //区域重置
                this.checkZoneIndex = null
                this.isSelectZone = ''
                this.zone = '请选择'
            },
            selectZone (index) {
                this.checkZoneIndex = index
                this.isSelectZone = 'cur'
                this.zone = this.zoneArr[index].s

                this.$emit('on-select', {province: this.province, city: this.city, zone: this.zone})
            }
        }
    }
</script>

<style lang="less" scoped>
    .hc {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        display: -webkit-flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-justify-content: center;
    }
    .el {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .city-select{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 101;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        .city-list{
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 500px;
            background-color: #fff;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            .list-title{
                padding-top: 20px;
                font-size: 15px;
            }
            .list-body{
                display: flex;
                display: -webkit-flex;
                padding-top: 20px;
                padding-left: 17px;
                padding-right: 17px;
                .list-item{
                    &.list-p{
                        width: 30%;
                    }
                    &.list-c{
                        width: 35%;
                    }
                    &.list-z{
                        width: 35%;
                    }
                    .selected-wrap{
                        position: relative;
                        height: 37px;
                        padding-bottom: 12px;
                        margin: 0 8px;
                        font-size: 15px;
                        font-weight: bold;
                        line-height: 1;
                        span{
                            display: block;
                            position: absolute;
                            padding: 4px 2px;
                            max-width: 100%;
                            &.cur{
                                border-bottom: #fbc500 solid 3px;
                            }
                        }
                    }
                    .options-wrap{
                        height: 355px;
                        font-size: 15px;
                        overflow-y: scroll;
                        li{
                            position: relative;
                            height: 40px;
                            padding: 8px 0;
                            span{
                                display: flex;
                                display: -webkit-flex;
                                align-items: center;
                                -webkit-align-items: center;
                                position: absolute;
                                top: 8px;
                                height: 24px;
                                max-width: 100%;
                                padding: 0 10px;
                                border-radius: 12px;
                                &.cur{
                                    background-color: #fbc500;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
